import { List } from '@mui/material';
import { styled } from '@mui/material/styles';

export const navigationCollapseIconStyle: React.CSSProperties = {
  marginTop: 'auto',
  marginBottom: 'auto',
};

export const NavigationCollapseListStyled = styled(List)({}) as typeof List;
